import { Carousel, CarouselVariant } from '@hse-design/core';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Vue } from 'vue-property-decorator';
import { EnumProp } from '../../utils/enumProp.js';
import __vue_component__ from '../../icons/action/arrow/keyboard/left/IconActionArrowKeyboardLeft.vue.js';
import __vue_component__$1 from '../../icons/action/arrow/keyboard/right/IconActionArrowKeyboardRight.vue.js';
import __vue_component__$2 from '../HseIconButton/HseIconButton.vue.js';
import __vue_component__$3 from './HseCarouselSlide.vue.js';

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=6665%3A2
 * @storybook /?path=/story/carousel-carousel--playground
 * @react /src-components-carousel
 * @reactStorybook /?path=/story/carousel-carousel--playground
 * @requires ./HseCarouselSlide.vue
 */
var HseCarousel = /** @class */ (function (_super) {
    __extends(HseCarousel, _super);
    function HseCarousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.carousel = {};
        _this.state = {
            $rootElement: undefined,
            activeSlideIndex: undefined,
            variant: _this.variant,
            autoplay: undefined,
            autoplayInterval: undefined,
            currentSlideIndex: 0,
            totalSlidesCount: 0,
            currentSlideNumberText: '',
            totalSlidesCountText: '',
            initialSlideIndex: _this.activeIndex
        };
        return _this;
    }
    Object.defineProperty(HseCarousel.prototype, "IconActionArrowKeyboardLeft", {
        get: function () {
            return __vue_component__;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseCarousel.prototype, "IconActionArrowKeyboardRight", {
        get: function () {
            return __vue_component__$1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseCarousel.prototype, "showNavigationText", {
        get: function () {
            var _a = this, variant = _a.variant, state = _a.state;
            var variants = ['fullScreen', 'horizontalSingle'];
            return variants.includes(variant) && state.currentSlideNumberText && state.totalSlidesCountText;
        },
        enumerable: false,
        configurable: true
    });
    HseCarousel.prototype.mounted = function () {
        this.carousel = new Carousel(this.setState, {
            $rootElement: this.$refs.container,
            activeSlideIndex: undefined,
            variant: this.variant,
            autoplay: this.autoplay,
            autoplayInterval: this.autoplayInterval,
            currentSlideIndex: 0,
            totalSlidesCount: 0,
            onChange: this.onChange,
            currentSlideNumberText: '',
            totalSlidesCountText: '',
            initialSlideIndex: this.activeIndex
        });
        this.carousel.onDidMount();
    };
    HseCarousel.prototype.beforeDestroy = function () {
        if (this.carousel)
            this.carousel.onWillUnmount();
    };
    HseCarousel.prototype.setState = function (newState) {
        if (typeof newState === 'object') {
            this.state = newState;
        }
        if (typeof newState === 'function') {
            this.state = newState(this.state);
        }
    };
    HseCarousel.prototype.onChange = function (currentSlideIndex) {
        /**
         * Событие смены слайда
         * @type {number}
         */
        this.$emit('change', currentSlideIndex);
    };
    HseCarousel.prototype.updated = function () {
        if (this.carousel)
            this.carousel.onUpdate({
                $rootElement: this.$refs.container,
                activeSlideIndex: this.activeIndex,
                variant: this.variant,
                autoplay: this.autoplay,
                autoplayInterval: this.autoplayInterval,
                initialSlideIndex: this.activeIndex,
                onChange: this.onChange
            });
    };
    HseCarousel.prototype.handleVariantChange = function (newVariant) {
        this.carousel.onVariantUpdated(newVariant);
    };
    HseCarousel.prototype.onPrevClick = function () {
        this.carousel.onPrevClick();
    };
    HseCarousel.prototype.onNextClick = function () {
        this.carousel.onNextClick();
    };
    __decorate([
        Prop({
            default: 0
        }),
        __metadata("design:type", Number)
    ], HseCarousel.prototype, "activeIndex", void 0);
    __decorate([
        Prop(EnumProp(CarouselVariant.fullScreen, CarouselVariant)),
        __metadata("design:type", String)
    ], HseCarousel.prototype, "variant", void 0);
    __decorate([
        Prop({
            default: true
        }),
        __metadata("design:type", Boolean)
    ], HseCarousel.prototype, "navigation", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseCarousel.prototype, "autoplay", void 0);
    __decorate([
        Prop({
            default: 5000,
            validator: function (value) {
                return Number.isInteger(value) && value >= 500;
            }
        }),
        __metadata("design:type", Number)
    ], HseCarousel.prototype, "autoplayInterval", void 0);
    __decorate([
        Prop({
            default: function () { return ({
                slides: '',
                footer: '',
                navigation: '',
                navigationButtons: '',
                navigationButton: '',
                navigationText: ''
            }); }
        }),
        __metadata("design:type", Object)
    ], HseCarousel.prototype, "classes", void 0);
    __decorate([
        Watch('variant'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], HseCarousel.prototype, "handleVariantChange", null);
    HseCarousel = __decorate([
        Component({
            name: 'HseCarousel',
            components: {
                HseIconButton: __vue_component__$2,
                HseCarouselSlide: __vue_component__$3
            },
            model: {
                prop: 'activeIndex',
                event: 'change'
            }
        })
    ], HseCarousel);
    return HseCarousel;
}(Vue));

export default HseCarousel;
